/* globals Class */
var h             = require('virtual-dom/h');
var createElement = require('virtual-dom/create-element');

var BaseDialog = require('./base_dialog');

var render = function(contentType) {
  return createElement(
    h('.modal-content-container.publishing-container', [
      h('.publish-publishing-header', [
        h('.publish-icon.publish-publishing-icon.loading-icon'),
        h('.publish-label .publishing', ['We are publishing your ', contentType.toLowerCase(), '...'])
      ]),
      h('.modal-panel-description', ['Feel free to browse away from here to keep working in',
                                     h('br'),
                                     'Unbounce, or stick around and you\'ll be able to continue',
                                     h('br'),
                                     'editing once republishing is complete.'
                                    ]),
      h('.modal-panel-tip', [
        h('.heads-up-icon .svg-ico-lightbulb'),
        h('p .publish-copy', [
          h('span .publish-label', 'Note: '),
          'Clear your cache or do a hard refresh if you don\'t see',
          h('br'),
          'your changes on the republished page. '
        ])
      ])
    ])
  );
};

var PublishingDialog = Class.create(BaseDialog, {

  initialize: function($super, options) {
    this.contentType = options.contentType;
    this.pageTitle = options.pageTitle || 'Your ' + this.contentType.toLowerCase();
    this.action = options.eventType === 'publishing' ? 'publish' : 'republish';

    options = {
      clickOutsideWillClose: false,
      allowHeader: true,
      attributes: {
        className: 'modal-panel modal-panel-publishing'
      }
    };

    $super(options);
  },

  installUI: function($super) {
    $super();

    this.setTitle(this.pageTitle + ' is being ' + this.action + 'ed...');
    this.setContent(render(this.contentType));
  }

});

module.exports = PublishingDialog;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/publishing.js